import { executionsConst } from 'features/executions'
import { type Dispatch, type SetStateAction, useId, useState } from 'react'
import { URLSearchParser } from 'shared/search-adapters'
import { ListSelect } from 'shared/ui'

import css from './Filters.module.css'

const info = executionsConst.qualificationInfo

const OPTIONS = executionsConst.QUALIFICATIONS.map(value => ({
	...info[value],
	value
}))

type StateOption = (typeof OPTIONS)[number]

function getInitial(param: URLSearchParams) {
	const globals = URLSearchParser.Array(param, 'n_liq' as any)

	const set = new Set(globals)

	return OPTIONS.filter(option => set.has(option.value))
}

NotQualificationsSelector.useState = (param: URLSearchParams) =>
	useState(getInitial(param))

export function NotQualificationsSelector({
	currents,
	setter
}: {
	currents: StateOption[]
	setter: Dispatch<SetStateAction<StateOption[]>>
}) {
	const id = useId()

	return (
		<div className={css.set}>
			<label className={css.label} htmlFor={id}>
				Qualification
			</label>
			<ListSelect
				formatOptionLabel={option => (
					<div style={{alignItems: 'center', display: 'flex', gap: 10}}>
						<img alt={option.label} src={option.emoji} />
						{option.label}
					</div>
				)}
				getOptionValue={option => option.value}
				getTag={option => `NOT: ${option.label}`}
				inputId={id}
				isMulti
				onChange={values => setter(Array.from(values))}
				options={OPTIONS}
				placeholder='Select status'
				setter={setter}
				value={currents}
			/>
		</div>
	)
}
